function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired4ad"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired4ad"] = parcelRequire;
}
parcelRequire.register("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = {};
function $18c11f3350a906ea$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$18c11f3350a906ea$var$mapping[keys[i]] = pairs[keys[i]];
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRequire.register("gK3KF", function(module, exports) {

module.exports = import("./" + (parcelRequire("27Lyk")).resolve("fy8yU")).then(()=>parcelRequire("3Qbrk"));

});

var $c8de8f9e0559fa12$exports = {};

(parcelRequire("27Lyk")).register(JSON.parse('{"ftxzc":"index.a50e7616.js","fy8yU":"success.694ab445.js"}'));

/* istanbul ignore file */ // @ts-ignore
function $150d3fe44d3ab232$export$e77603c386a58f22(url, validHostnames) {
    const { hostname: hostname } = url;
    const hostnameWithWww = `www.${hostname}`;
    if (!validHostnames.includes(hostname) && !validHostnames.includes(hostnameWithWww)) throw new Error(`${hostname} is not a valid tripadvisor url`);
}


// Array.from($$('link[hrefLang]')).map((el)=>{return new URL(el.href).hostname})
const $84d19d9262d60c9b$export$953359561b926ba = [
    "www.tripadvisor.com",
    "www.tripadvisor.co.uk",
    "www.tripadvisor.ca",
    "fr.tripadvisor.ca",
    "www.tripadvisor.it",
    "www.tripadvisor.es",
    "www.tripadvisor.de",
    "www.tripadvisor.fr",
    "www.tripadvisor.jp",
    "cn.tripadvisor.com",
    "www.tripadvisor.in",
    "www.tripadvisor.se",
    "www.tripadvisor.nl",
    "www.tripadvisor.com.br",
    "www.tripadvisor.com.tr",
    "www.tripadvisor.dk",
    "www.tripadvisor.com.mx",
    "www.tripadvisor.ie",
    "ar.tripadvisor.com",
    "www.tripadvisor.com.eg",
    "www.tripadvisor.cz",
    "www.tripadvisor.at",
    "www.tripadvisor.com.gr",
    "www.tripadvisor.com.au",
    "www.tripadvisor.com.my",
    "www.tripadvisor.co.nz",
    "www.tripadvisor.com.ph",
    "www.tripadvisor.com.sg",
    "www.tripadvisor.co.za",
    "www.tripadvisor.com.ar",
    "www.tripadvisor.cl",
    "www.tripadvisor.co",
    "www.tripadvisor.com.pe",
    "www.tripadvisor.com.ve",
    "www.tripadvisor.fi",
    "www.tripadvisor.co.hu",
    "www.tripadvisor.co.id",
    "www.tripadvisor.co.il",
    "www.tripadvisor.co.kr",
    "no.tripadvisor.com",
    "pl.tripadvisor.com",
    "www.tripadvisor.pt",
    "www.tripadvisor.ru",
    "www.tripadvisor.sk",
    "www.tripadvisor.rs",
    "th.tripadvisor.com",
    "www.tripadvisor.com.vn",
    "www.tripadvisor.com.tw",
    "www.tripadvisor.ch",
    "fr.tripadvisor.ch",
    "it.tripadvisor.ch",
    "en.tripadvisor.com.hk",
    "fr.tripadvisor.be",
    "www.tripadvisor.be",
    "www.tripadvisor.com.hk"
];
$84d19d9262d60c9b$export$953359561b926ba.push("tripadvisor.com");


function $f8a81a4ab89d5b19$export$a22775fa5e2eebd9(url) {
    (0, $150d3fe44d3ab232$export$e77603c386a58f22)(url, (0, $84d19d9262d60c9b$export$953359561b926ba));
}


class $fb6e3c305fbfeb1e$export$e94a5e0d272668a0 {
    init(parent) {
        this.el = parent.querySelector("#url");
        this.el.addEventListener("paste", ()=>{
            setTimeout(()=>{
                parent.dispatchEvent(new Event("submit", {
                    cancelable: true
                }));
            }, 1);
        });
        return this;
    }
    setFocus() {
        this.el.focus();
    }
    setValue(val) {
        this.el.value = val;
    }
    getValue() {
        return this.el.value;
    }
}


class $2bc29ea4e0fb00e6$export$8b7b7cdfb85d78c5 {
    init(parent) {
        this.el = parent.querySelector("button");
        this.el.classList.remove("cursor-not-allowed");
        this.submitIcon = this.el.querySelector(".js-submit-icon");
        this.spinnerIcon = this.el.querySelector(".js-spinner-icon");
        return this;
    }
    loadingStart() {
        this.submitIcon.classList.add(this.hiddenClassName);
        this.spinnerIcon.classList.remove(this.hiddenClassName);
    }
    loadingStop() {
        this.submitIcon.classList.remove(this.hiddenClassName);
        this.spinnerIcon.classList.add(this.hiddenClassName);
    }
    constructor(){
        this.hiddenClassName = "hidden";
    }
}


class $5df7e6935ffc0dce$export$5ebc9a4af3ac0850 {
    constructor(doc){
        this.hiddenClassName = "hidden";
        this.doc = doc;
    }
    init() {
        this.el = this.doc.querySelector(".failure");
        return this;
    }
    show(msg) {
        this.el.querySelector("p").innerHTML = msg;
        this.el.classList.remove(this.hiddenClassName);
    }
    hide() {
        this.el.classList.add(this.hiddenClassName);
    }
}



class $02f2cad99c8abd8f$export$a7fed597f4b8afd8 {
    constructor(document){
        this.doc = document;
    }
    async submit(e) {
        e.preventDefault();
        this.doc.dispatchEvent(new CustomEvent("success.hide"));
        this.failure.hide();
        try {
            const url = new URL(this.urlInput.getValue());
            (0, $f8a81a4ab89d5b19$export$a22775fa5e2eebd9)(url);
            this.submitButton.loadingStart();
            const [res] = await Promise.all([
                fetch(`/api?url=${url}`),
                (parcelRequire("gK3KF"))
            ]);
            this.submitButton.loadingStop();
            if (res.ok) {
                const detail = await res.json();
                this.doc.dispatchEvent(new CustomEvent("success.show", {
                    detail: detail
                }));
                const newURL = new URL(window.location.href);
                newURL.searchParams.set("url", url.href);
                if (window.location.href !== newURL.href) window.history.pushState(null, "", newURL.href);
            } else throw new Error("profile not found. try something like https://www.tripadvisor.com/Profile/theplanetd");
        } catch (e) {
            this.urlInput.setFocus();
            this.failure.show(e.message);
            console.log(e.stack);
        }
    }
    init() {
        this.el = this.doc.querySelector("form");
        this.el.addEventListener("submit", (e)=>this.submit(e));
        this.doc.addEventListener("invalid", (()=>{
            return (e)=>{
                e.preventDefault();
                this.urlInput.setFocus();
            };
        })(), true);
        this.urlInput = new (0, $fb6e3c305fbfeb1e$export$e94a5e0d272668a0)().init(this.el);
        this.submitButton = new (0, $2bc29ea4e0fb00e6$export$8b7b7cdfb85d78c5)().init(this.el);
        this.failure = new (0, $5df7e6935ffc0dce$export$5ebc9a4af3ac0850)(this.doc).init();
        return this;
    }
    autoSubmit(url) {
        this.urlInput.setValue(url);
        this.el.dispatchEvent(new Event("submit", {
            cancelable: true
        }));
    }
}


class $3e1bd4db2bc1d576$export$69d3b9635995fa43 {
    constructor(document1){
        this.doc = document1;
    }
    static timeSince(currentDate, date) {
        const seconds = Math.floor((currentDate.getTime() - date.getTime()) / 1000);
        const plural = (interval)=>{
            return `${Math.floor(interval) > 1 ? "s" : ""}`;
        };
        let interval = seconds / 31536000;
        if (interval > 1) return `${Math.floor(interval)} year${plural(interval)}`;
        interval = seconds / 2592000;
        if (interval > 1) return `${Math.floor(interval)} month${plural(interval)}`;
        interval = seconds / 86400;
        if (interval > 1) return `${Math.floor(interval)} day${plural(interval)}`;
        interval = seconds / 3600;
        if (interval > 1) return `${Math.floor(interval)} hour${plural(interval)}`;
        interval = seconds / 60;
        if (interval > 1) return `${Math.floor(interval)} minute${plural(interval)}`;
        return `${Math.floor(seconds)} second${plural(seconds)}`;
    }
    async handler(e) {
        this.tableBody.classList.add("hidden");
        e.preventDefault();
        const url = e.target.getAttribute("href");
        const res = await (await fetch(url)).json();
        this.render(res);
    }
    async init() {
        this.el = this.doc.querySelector(".highscore");
        this.tableBody = this.el.querySelector("table tbody");
        const switches = Array.from(this.doc.querySelectorAll(".highscore__switch"));
        const events = [
            "click",
            "init"
        ];
        switches.map((el)=>{
            events.map((event)=>{
                el.addEventListener(event, (evt)=>this.handler(evt));
            });
        });
        switches[0].dispatchEvent(new CustomEvent("init"));
    }
    render(highscore) {
        const currentDate = new Date();
        const new_tbody = document.createElement("tbody");
        const classes = [
            "lg:px-4",
            "border",
            "px-1",
            "py-2"
        ].join(" ");
        const emoji = [
            " \uD83C\uDFC6 ",
            " \uD83E\uDD48 ",
            " \uD83E\uDD49 "
        ];
        highscore.forEach(({ username: username, cities: cities, countries: countries, date: date, url: url }, index)=>{
            const html = `
      <td class="${classes}"><a class="no-underline" href="/?url=${url}">${emoji[index] ? emoji[index] : `${index + 1}.`}</a></td>
      <td class="${classes}"><a rel="noopener noreferrer nofollow" target="_blank" href="${url}">${username}</a></td>
      <td class="${classes} text-right">${countries}</td>
      <td class="${classes} text-right">${cities}</td>
      <td class="${classes} text-right">${$3e1bd4db2bc1d576$export$69d3b9635995fa43.timeSince(currentDate, new Date(date))} ago</td>`;
            const row = new_tbody.insertRow();
            row.innerHTML = html;
            let className = "bg-gray-100";
            if (index % 2) className = "bg-white";
            row.classList.add(className);
        });
        this.tableBody.parentNode.replaceChild(new_tbody, this.tableBody);
        this.tableBody = new_tbody;
        this.el.classList.remove("hidden");
    }
}


const $a957e762f603007c$var$form = new (0, $02f2cad99c8abd8f$export$a7fed597f4b8afd8)(document).init();
new (0, $3e1bd4db2bc1d576$export$69d3b9635995fa43)(document).init();
const $a957e762f603007c$var$url = new URLSearchParams(window.location.search).get("url");
if ($a957e762f603007c$var$url) $a957e762f603007c$var$form.autoSubmit($a957e762f603007c$var$url);
window.addEventListener("popstate", ()=>{
    const url = new URLSearchParams(window.location.search).get("url");
    if (!url) document.dispatchEvent(new CustomEvent("success.hide"));
    else $a957e762f603007c$var$form.autoSubmit(url);
});


//# sourceMappingURL=index.a50e7616.js.map
